import './App.css';


import React, { useState } from 'react';
// import CameraDetection from './Components/CameraDetection';
import NavBar from './Components/NavBar';
import  LeftSlide  from './Components/LeftSlide'; // Remove isCameraOn import
import Camera from './Components/Camera';
// import RightSlide from './Components/RightSlide';



function App() {
  
  const [isCameraOn, setIsCameraOn] = useState(false);
  const webcamRef = React.useRef(null);
  return (
    
    <div className="App">
      <NavBar />

      <br></br>
      
      <div className='body'>
        <div className="screen">
        <div className='leftslide'>
          <LeftSlide setIsCameraOn={setIsCameraOn} webcamRef={webcamRef}/>
        </div>
        <div className='camera'>
          <Camera isCameraOn={isCameraOn} webcamRef={webcamRef}/>
        {/* <div id="imagePreview" className='hidden'/> */}
        </div>

       
        </div>
      </div>
    </div>
  );
}

export default App;